import { render, staticRenderFns } from "./the-voice-dialog.vue?vue&type=template&id=522fa173&scoped=true&"
import script from "./the-voice-dialog.vue?vue&type=script&lang=js&"
export * from "./the-voice-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522fa173",
  null
  
)

export default component.exports